import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { string } from "prop-types";

import "./icons.m.css";

if (require.context) {
  const req = require.context("../../../assets/icons/", true, /\.svg$/);
  req.keys().forEach(filename => req(filename));
}

const IconBase = ({ type, className = "", iconSpritePath }) => {
  if (!type) return null;
  return (
    <svg className={className} styleName="svg-icon">
      <use href={`${iconSpritePath}#${String(type).toLowerCase()}`} />
    </svg>
  );
};

function mapStateToProps(state) {
  return {
    iconSpritePath: get(state, ["qt", "config", "iconSpritePath"])
  };
}

IconBase.propTypes = {
  type: string,
  className: string,
  iconSpritePath: string
};

export const Icon = connect(mapStateToProps)(IconBase);

export default Icon;
